import { useParams } from "react-router-dom";
import { legalPages, type LegalPageKey } from "../../config/legal";
import { Card } from "../components/ui/Card";
import { Section } from "../components/ui/Section";

function isLegalPageKey(page: string | undefined): page is LegalPageKey {
  return page === "terms" || page === "privacy" || page === "cookies" || page === "refund";
}

export function LegalPage() {
  const { page } = useParams();
  const content = isLegalPageKey(page) ? legalPages[page] : legalPages.terms;

  return (
    <Section className="py-12 sm:py-16">
      <Card className="mx-auto max-w-3xl">
        <p className="text-sm font-semibold text-cyan-100">Τελευταία ενημέρωση: 2026</p>
        <h1 className="mt-4 text-3xl font-bold text-white">{content.title}</h1>
        <div className="mt-5 grid gap-4 text-slate-300">
          {content.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </Card>
    </Section>
  );
}
